export interface RuntimeProbe {
  kind: "web" | "tauri";
  platform: string;
  storageReady: boolean;
  databaseFileName: string | null;
  deviceId: string | null;
}

export function isTauriRuntime() {
  return typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;
}

export function applyRuntimeDocumentState(runtime: RuntimeProbe, root = document.documentElement) {
  root.dataset.runtime = runtime.kind;
  root.dataset.platform = runtime.platform;
}

export async function probeRuntime(): Promise<RuntimeProbe> {
  if (!isTauriRuntime()) {
    try {
      const { browserDeviceId, browserSecureStorageReady } = await import("./browserSecureMedia");
      const storageReady = await browserSecureStorageReady();
      return {
        kind: "web",
        platform: "browser",
        storageReady,
        databaseFileName: storageReady ? "IndexedDB" : null,
        deviceId: storageReady ? await browserDeviceId() : null
      };
    } catch {
      return { kind: "web", platform: "browser", storageReady: false, databaseFileName: null, deviceId: null };
    }
  }

  try {
    const { invoke } = await import("@tauri-apps/api/core");
    return await invoke<RuntimeProbe>("probe_local_runtime");
  } catch {
    return { kind: "tauri", platform: "unknown", storageReady: false, databaseFileName: null, deviceId: null };
  }
}
